import { render, staticRenderFns } from "./judgeIndex.vue?vue&type=template&id=741dcbdb&scoped=true&"
import script from "./judgeIndex.vue?vue&type=script&lang=js&"
export * from "./judgeIndex.vue?vue&type=script&lang=js&"
import style0 from "./judgeIndex.vue?vue&type=style&index=0&id=741dcbdb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741dcbdb",
  null
  
)

export default component.exports